import { isElementOutOfViewport } from "./HelperFunctions";

export const showStickyApply = () => {
    const body = document.querySelector(".job-details");
    const stickyApply = document.querySelector(".sticky-apply");

    if (!body && !stickyApply) return;

    const hero = document.querySelector(".job-details__hero");

    if (!hero) return;

    document.addEventListener("scroll", () => {
        const viewPortCheck = isElementOutOfViewport($(hero)[0]);

        switch (true) {
            case viewPortCheck:
                stickyApply?.classList.add("sticky-apply--visible");
                break;
            default:
                stickyApply?.classList.remove("sticky-apply--visible");
                break;
        }
    });
};
